module.exports = __webpack_public_path__ + "static/media/showers.53a4986c.jpg";